module.exports = __webpack_public_path__ + "img/airplane-down.e62f2acc.svg";